import { defineMessages } from 'react-intl';

export default defineMessages({
  displayedSurvey: 'Displayed version',
  displayedSurveyHelp: 'Controls what questions are shown in the results and segment filter. The data included is not filtered by this choice.',
  dateRange: 'Date range',
  startDate: 'Start date',
  endDate: 'End date',
  year: 'Year',
  month: 'Month',
  week: 'Week',
  day: 'Day',
  lastYear: 'Last year',
  lastMonth: 'Last month',
  lastWeek: 'Last week',
  filters: 'Active content filters: {filters}',
  allResultsCount: `{count, plural,
    =0 {No responses}
    one {1 response}
    other {# responses}
  }`,
  resultsCount: `{count, plural,
    =0 {No responses}
    other {# ({percent}%)}
  }`,
  date: 'Date',
  text: 'Text',
  responses: 'Responses',
  percentage: '{value}%',
  segmentName: 'Segment name',
  noContent: 'You dont have any surveys of this type',
  addSegment: 'Create segment',
  filterLimit: 'Maximum two filters allowed',
  showAll: 'Show only active filters',
  urlLabel: 'Visited page url',
  pageTitleLabel: 'Visited page title',
  eventCategoryLabel: 'Event category',
  eventActionLabel: 'Event action',
  eventNameLabel: 'Event name',
  goalIdLabel: 'Goal',
  deviceTypeLabel: 'Device type',
  deviceLabel: 'Device type',
  countryCodeLabel: 'Country (based on IP)',
  regionIdLabel: 'Region',
  municipalityIdLabel: 'Municipality',
  languageCodeLabel: 'Browser language',
  languageLabel: 'Browser language',
  browserLabel: 'Browser version',
  browserNameLabel: 'Browser',
  operatingSystemLabel: 'OS version',
  operatingSystemNameLabel: 'OS',
  referrerTypeLabel: 'Channel type',
  referrerNameLabel: 'Channel name',
  referrerUrlLabel: 'Channel url',
  referrerKeywordLabel: 'Channel keyword',
  webpageUrlLabel: 'Response page url',
  webpageTitleLabel: 'Response page title',
  surveyLabel: 'Survey',
  surveyLanguageLabel: 'Language',
  websiteLabel: 'Website',
  clientPanelLabel: 'Client panel participation',
  website: 'Website interaction',
  question: 'Questions',
  survey: 'Survey',
  taggedfields: 'Tagged Comments',
  respondent: 'Respondent',
  segmentation: 'Segmentation',
  benchmarks: 'Industry benchmarks',
  benchmarksHelp: 'Compare your score against other surveys. The benchmark is a three year average of at least five different surveys. Only applicable to our standardized "Find", "Grade" and "NPS" questions',
  noWebsites: 'None',
  noFilters: 'No filters',
  enableSegment: 'Enable segment',
  disableSegment: 'Disable segment',
  duplicateSegment: 'Duplicate',
  minEnabledSegments: 'You need to have at least one segment enabled',
  maxEnabledSegments: 'You can only enable {max} segments at a time',
  noResponsesWithinDateRange: '* = Option has no responses within selected time period',
  syncToMatomo: 'Available in analytics',
  syncToMatomoTooltip: 'You can use this segment to filter the analytics data.',
  syncToWebsite: 'Website',
  matomoCustomDimension: 'Segment slot',
  sharedSegment: 'Shared segment',
  sharedSegmentTooltip: 'Segment is shared to all users',
  sharedByTooltip: 'Shared by {createdByEmail}',
  mergedSegment: 'Filters are combined from an existing segment and the result you clicked.',
  filterOptionsOperator: 'Combine filters with',
  filterOptionsOperatorAnd: 'And - All of the filters must match',
  filterOptionsOperatorOr: 'Or - One of the filters must match',
  filterOptionsInverted: 'Inverted filter (show the opposite of the selected filters)',
  filterCategories: 'Filter categories',
  tagsDescription: 'Select suggestions from the list or type any text to filter on results containing that text. Filter is case insensitive.',
  globalSegmentInfo: 'This segment is using the global segment {globalSegmentName}. You can give it a different local name if you want. Removing it only removes your local version of the segment. If you want to change the filter you need to edit the global segment.',
});
